// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_47-0";